import React, { useEffect, useState } from "react";
import { navigate } from "@reach/router";
import AuthService from "../services/AuthService";

export const UserContext = React.createContext();

function UserProvider({ children }) {
  const [token, setToken] = useState(null);
  const [userObject, setUserObject] = useState({});
  const [password, setPassword] = useState(null);
  const [trackingToken, setTrackingToken] = useState();

  useEffect(() => {
    try {
      function getToken() {
        try {
          const local_token = localStorage.getItem("auth_token");
          const local_token_password = localStorage.getItem("change-password");
          if (local_token) setToken(local_token);
          if (local_token_password) setPassword(local_token_password);
        } catch (error) {
          console.log(error);
        }
      }
      getToken();
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    async function fetchUserProfile() {
      try {
        const user = await AuthService.profile();
        if (user?.me) {
          setUserObject(user.me);
        }
      } catch (error) {}
    }
    try {
      if (token) {
        if (token === "logged_out") {
          localStorage.setItem("auth_token", "");
          navigate("/");
          setUserObject({});
          setToken(null);
        } else {
          localStorage.setItem("auth_token", token);
          localStorage.setItem("change-password", password);
          fetchUserProfile();
        }
      }
    } catch (error) {
      console.log(error);
    }
  }, [token, password]);

  const value = React.useMemo(() => {
    return {
      token,
      setToken,
      userObject,
      setUserObject,
      password,
      setPassword,
      trackingToken,
      setTrackingToken,
    };
  }, [
    token,
    setToken,
    userObject,
    password,
    setPassword,
    setUserObject,
    trackingToken,
    setTrackingToken,
  ]);

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}

export default UserProvider;
